import { Box, Grid, styled, Typography } from "@mui/material";

const CardWrapper = styled(Box)(
  ({ theme }) => `
    border-radius: 14px;
    background: #FFF;
    box-shadow: 6px 6px 54px 0px rgba(0, 0, 0, 0.05);
    padding: 20px;
    position: relative;
    overflow: hidden;

    & .MuiTypography-h2 {
      color: #202224;
      font-size: 48px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      text-align: center;
    }

    & .MuiTypography-h4 {
      color: #202224;
      font-size: 24px;
      letter-spacing: 1px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      text-align: center;
      width: 100%;
    }

    & .iconContainer {
      position: absolute;
      top: 15%;
      right: 5%;
    }
  `
);

const IconContainer = styled(Box)(
  ({ theme }) => `
    display: inline-block;
  `
);

interface CardProps {
  number: string | number;
  title: string;
  Icon: React.ReactNode;
}

const CardTiles: React.FC<CardProps> = ({ number, title, Icon }) => {
  return (
    <CardWrapper>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item xs={12}>
          <Typography variant="h2">{number}</Typography>
        </Grid>
        <div className="iconContainer">{Icon}</div>
        <Grid item xs={12}>
          <Typography variant="h4">{title}</Typography>
        </Grid>
      </Grid>
    </CardWrapper>
  );
};

export default CardTiles;
